export const lightgrey = {
    font: {
        sz: 11,
    },
    fill: { 
        patternType: "solid",
        fgColor: { rgb: "FFf0f0f0" },
    },
    border: {
        top: { style: "thin", color: { auto: 1 } },
        right: { style: "thin", color: { auto: 1 } },
        bottom: { style: "thin", color: { auto: 1 } },
        left: { style: "thin", color: { auto: 1 } }
    }
}

export const lightblue = {
    font: {
        sz: 11,
    },
    fill: { 
        patternType: "solid",
        fgColor: { rgb: "FFdcf5fb" },
    },
    border: {
        top: { style: "thin", color: { auto: 1 } },
        right: { style: "thin", color: { auto: 1 } },
        bottom: { style: "thin", color: { auto: 1 } },
        left: { style: "thin", color: { auto: 1 } }
    }
}

export const lightyellow = {
        font: {
            sz: 11,
        },
        fill: { 
            patternType: "solid",
            fgColor: { rgb: "FFfbf2dc" },
        },
        border: {
            top: { style: "thin", color: { auto: 1 } },
            right: { style: "thin", color: { auto: 1 } },
            bottom: { style: "thin", color: { auto: 1 } },
            left: { style: "thin", color: { auto: 1 } }
        }
}

export const lightpurple = {
    font: {
        sz: 11,
    },
    fill: { 
        patternType: "solid",
        fgColor: { rgb: "FFdcdefb" },
    },
    border: {
        top: { style: "thin", color: { auto: 1 } },
        right: { style: "thin", color: { auto: 1 } },
        bottom: { style: "thin", color: { auto: 1 } },
        left: { style: "thin", color: { auto: 1 } }
    }
}

export const lightpink = {
    font: {
        sz: 11,
    },
    fill: { 
        patternType: "solid",
        fgColor: { rgb: "FFfbdedc" },
    },
    border: {
        top: { style: "thin", color: { auto: 1 } },
        right: { style: "thin", color: { auto: 1 } },
        bottom: { style: "thin", color: { auto: 1 } },
        left: { style: "thin", color: { auto: 1 } }
    }
}

export const editDateForExcel = (date: string) => {
    if (date == "") return ""

    const checkDate = date.split("/").length
    if (checkDate < 3) return

    const [ day, month, year ] = date.split("/")
    let inDate =  new Date(`${month}/${day}/${year}`)
    var returnDateTime = 25569.0 + ((inDate.getTime() - (inDate.getTimezoneOffset() * 60 * 1000)) / (1000 * 60 * 60 * 24));
    return parseInt(returnDateTime.toString().substr(0,5));
}